export const ACCENTS = {
  blue:   { name: 'Azul Corporativo', brand: '#4f8ef7', soft: 'rgba(79,142,247,0.15)',  glow: 'rgba(79,142,247,0.3)' },
  green:  { name: 'Esmeralda',        brand: '#10b981', soft: 'rgba(16,185,129,0.15)', glow: 'rgba(16,185,129,0.3)' },
  purple: { name: 'Ametista',         brand: '#8b5cf6', soft: 'rgba(139,92,246,0.15)', glow: 'rgba(139,92,246,0.3)' },
  orange: { name: 'Laranja',          brand: '#f97316', soft: 'rgba(249,115,22,0.15)', glow: 'rgba(249,115,22,0.3)' },
  rose:   { name: 'Rosa',             brand: '#f43f5e', soft: 'rgba(244,63,94,0.15)',  glow: 'rgba(244,63,94,0.3)' },
  cyan:   { name: 'Ciano',            brand: '#06b6d4', soft: 'rgba(6,182,212,0.15)',  glow: 'rgba(6,182,212,0.3)' },
};

export const DEFAULT_ACCENT = 'blue';
